import React from 'react'
import { Box } from '@mui/material'
import VISUALLY_HIDDEN from '../a11y'

export type StreamingStatusAnnouncerProps = {
  status: string | null
}

/**
 * Visually-hidden aria-live region that announces tool-status changes to
 * screen readers. Memoized on the `status` prop so the typewriter rerendering
 * the chat bubble at 25fps does not cause NVDA/JAWS to re-announce identical
 * text. Mount once in AssistantChat and feed it currentStatus.
 */
const StreamingStatusAnnouncer = React.memo(({ status }: StreamingStatusAnnouncerProps) => (
  <Box
    role="status"
    aria-live="polite"
    aria-atomic="true"
    data-testid="streaming-status-announcer"
    sx={VISUALLY_HIDDEN}
  >
    {status ?? ''}
  </Box>
))

StreamingStatusAnnouncer.displayName = 'StreamingStatusAnnouncer'

export default StreamingStatusAnnouncer
